import {PureComponent,register} from './component';
import {render,unmountComponentAtNode} from 'react-dom';
import React from 'react';
import {Provider as RootProvider} from '@hooks/use-root';

export class ReactMountComponent extends PureComponent {
  create(){
    const RootComponent = this.render;
    if(typeof RootComponent !== 'function'){
      return;
    }

    const childNodes = [];

    const props = {...this.props};

    while(this.el.firstChild){
      const child = this.el.firstChild;
      this.el.removeChild(child);
      if(child.tagName==='SCRIPT' && child.type==='application/json'){
        try{
          const config = JSON.parse(child.textContent);
          Object.assign(props,config);
        }catch(e){
          console.warn('invalid config ', child, e, child.textContent);
        }
      }else{
        childNodes.push(child);
      }
    }

    render(<RootProvider value={this.el}><RootComponent {...props} childNodes={childNodes} rootElement={this.el} /></RootProvider>,this.el);
  }

  destroy(){
    unmountComponentAtNode(this.el);
    super.destroy();
  }
}

export default (selector,renderer) => (
  register(
    class MountComponent extends ReactMountComponent {
      static selector = selector
      render(...args){
        return renderer(...args);
      }
    }
  )
);